import Alpine from 'alpinejs';
import Cookies from 'js-cookie';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import smoothscroll from 'smoothscroll-polyfill';
import Packery from 'packery';
import { animations } from './modules/animations';

// Swiper Configuration
import 'swiper/css';
import 'swiper/css/effect-fade';

window.Swiper = Swiper;
Swiper.use([Autoplay]);
Swiper.use([Navigation]);
Swiper.use([Pagination]);
Swiper.use([EffectFade]);

// GSAP Configuration
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.Packery = Packery;
window.Cookies = Cookies;

// Smooth Scroll polyfill for Safari (iOS)
smoothscroll.polyfill();

// Alpine Configuration
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	animations();
});
